import { AppServices } from '@singularsystems/neo-core';
import { AppService, AppTypes } from 'st-app/Services/AppService';
import { ParticipantsSharedTypes } from './ParticipantsSharedTypes';
import { CommonParticipantsTypes } from 'st-common/Participants/CommonParticipantTypes';
import { IParticipantsAppCatalogueApiClient } from './ApiClients/ParticipantsAppCatalogueApiClient';

const Types = {
    ...AppTypes,
    Participants: {
        ApiClients: {
            MainApiClient: ParticipantsSharedTypes.ApiClients.MainApiClient,
            CatalogueApiClient: new AppServices.ServiceIdentifier<IParticipantsAppCatalogueApiClient>("Participants.ApiClients.CatalogueApiClient"),
            BeneficiariesApiClient: CommonParticipantsTypes.ApiClients.BeneficiariesApiClient,
        },

        Services: {
            ...CommonParticipantsTypes.Services,
            ...ParticipantsSharedTypes.Services
        }
    }
}

export { AppService, Types }
